import { computed } from "mobx";

export default class EventModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      caption: this.caption,
      event_type: this.event_type,
      max_occurrence: this.max_occurrence,
      duration: this.duration,
      interval: this.interval,
      check_ids: this.check_ids,

      //template
      summary: this.summary,
      description: this.description,
      generated_date: this.generated_date,
      end_date: this.end_date,
      status_id: this.status_id,
      reason_id: this.reason_id,
      action_id: this.action_id,
      station_id: this.station_id,
      name: this.name,
      mobile_no: this.mobile_no,
      email_address: this.email_address,
      user_id: this.user_id,
      assigned_to: this.assigned_to,
      archived: this.archived,
      valid_days: this.valid_days,
      sms_notify: this.sms_notify,

      //event_buffer
      // event_buffers: this.event_buffers,

      //event_tickets
      event_tickets: this.event_tickets,

      //followers
      followers: this.followers,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.caption = json.caption;
    this.event_type = json.event_type;
    this.max_occurrence = json.max_occurrence;
    this.duration = json.duration;
    this.interval = json.interval;
    this.check_ids = json.check_ids;
    //template
    this.summary = json.summary;
    this.description = json.description;
    this.generated_date = json.generated_date;
    this.end_date = json.end_date;
    this.status_id = json.status_id;
    this.reason_id = json.reason_id;
    this.action_id = json.action_id;
    this.station_id = json.station_id;
    this.name = json.name;
    this.mobile_no = json.mobile_no;
    this.email_address = json.email_address;
    this.user_id = json.user_id;
    this.assigned_to = json.assigned_to;
    this.archived = json.archived;
    this.valid_days = json.valid_days;
    this.sms_notify = json.sms_notify;

    //event_buffer
    // this.event_buffers = json.event_buffers || this.event_buffers;

    //event_tickets
    this.event_tickets = json.event_tickets || this.event_tickets;

    //followers
    this.followers = json.followers;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Event/EventModel.js